const state = {
    welcome: [],
    marca:[],
    loading: false,
    loadingMarca: false,
};

export default state;